<template>
<div class="popup" v-show="addItemSubAccountShow" element-loading-background="rgba(0, 0, 0, 0.1)" v-cloak>
    <div id="add-item-sub-account" class="content" >
        <div class="title">
            <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
            <div class="icon white-close dialog-close" @click="closeTreeDialog()"></div>
        </div>
        <div class="task-content"  ref="copyTree" :style="flowShow?'pointer-events: none;':''" v-loading="loading">
            <el-scrollbar style="height:100%;" ref="subAddItemScroll">
            <div class="tree-nodes">
                <div v-show="isCloudsNull&&!loading" @click="toAddCloudPage()"><span class="tree-nocloud">{{$t('language.sharesPage.mustAddClouds')}}</span></div>
                <ul :key=index v-for="(item,index) in model">
                    <tree ref="tree" :model="item" :index=index :treeShow=true transferAimFlag='addSubItem'></tree>
                </ul>
            </div>
            </el-scrollbar>
        </div>
        <div class="task-footer" :style="flowShow?'pointer-events: none;':''">
            <!-- <div class="icon-util nocheck move-position" :class="[$store.state.multiSelect==true?'check':'']" @click="multi($event)"></div>
            <div class="multi-select">{{$t('language.common.multiSelect')}}</div> -->
            <button class="task-button"  v-show="!loading" :style="flowShow?'background-color: #dcdfe6;':''" @click="addItems()" v-loading="loadingStart">{{$t('language.common.ok')}}</button>
        </div>
    </div>
    <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tree from '@/components/common/trees/sub_account_tree';
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import Utils from '@/js/request_util';
import commonstate from '@/js/constant.js';
//显示账号升级弹窗
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
export default {
    components: {
        tree,
        upgradeNewDialog,
    },
    data: function () {
        return {
            user: commonstate.user,
            addItemSubAccountShow: false,
            model: [],
            loading: false,
            flowShow :false,
            isCloudsNull: false,
            loadingStart: false,//startCopyTo按钮
            subAccountEmail: "",
        }
    },
    inject: ["reload"],
    mounted() {
        this.$store.commit('setClickItem', null);
        this.$store.state.arr = [];
    },
    created() {
    },
    watch: {
        model(val){
            if (val.length<1) {
                this.isCloudsNull = true;
            }else{
                this.isCloudsNull = false;
            } 
        },
        addItemSubAccountShow(val){
            if(val){
                this.$store.commit('setMultiSelect', true);
            }
        }
    },
    methods: {
        initData() {
            let that = this;
            this.loading = true;
            let tempModel;
            tempModel = Object.assign([], this.$store.getters.getUsersDrives);
            if (!tempModel.length) {
                tempModel = this.Utils.getAllCloudsList(function (res) {
                    if (res.status == 200) {
                        $.each(tempModel, function (index, item) {

                            item.open = false;
                        });
                        that.loading = false;
                    }
                });
            } else {
                $.each(tempModel, function (index, item) {
                    item.open = false;
                });
                this.loading = false;
            }
            this.model = tempModel.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        },
        //用户执行多选的复制操作
        multi(event) {
            let dom = event.currentTarget;
            if (this.$store.state.multiSelect == true) {
                this.$store.commit('setMultiSelect', false);
                this.$store.state.arr = [];
            } else {
                this.$store.commit('setMultiSelect', true);
                this.$store.commit('setTreeMoveSelect', false);
            }
        },
        closeTreeDialog() {
            $.each(this.model, function (index, item) {
                item.open = false;
                if (item.children && item.children.length) {
                    commonUtils.closeTree(item.children);
                }
            });
            this.$store.commit('setClickItem', -1);
            this.$store.commit('setMultiSelect', false);
            this.$store.commit('setTreeMoveSelect', false);
            this.$store.commit('setClickItem', null);
            this.$store.state.arr = [];
            this.model = [];
            this.$refs.subAddItemScroll.$refs.wrap.scrollTop = 0;
            this.addItemSubAccountShow = false; 
            this.loadingStart = false;
        },
        addItems(){
            let that = this;
            let user=commonUtils.getUser();
            if(!user.vip){
                var upgradeNewDialog = this.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_subtasks');
                upgradeNewDialog.curItem = 'subtasks';
                upgradeNewDialog.isShow = true;
                return;
            }
            let aimItems = this.$store.state.arr;
            if(!aimItems||aimItems.length<1){
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addItem.noFolder'),
                    type: 'fail',
                    idValue: "add-item-sub-account"
                });
                return false;
            }
            let data = {
                ud : this.user.id,
            }
            let addList = [];
            aimItems.forEach(v => {
                const temp = {
                    cloudType: v.driveType,
                    cloudId: v.driveId?v.driveId:v.id,
                    folderId: v.driveId?v.id:v.rootId,
                    folderName: that.getFolderName(v),
                }
                addList.push(temp);
            })
            data.list = addList;
            if(this.subAccountEmail){
                data.emailId = this.subAccountEmail;
            }
            this.loadingStart = true;
            this.Utils.doPermissionRequest("add_item", data).then(res => {
                this.loadingStart = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();
                    this.closeTreeDialog();
                }else if(res.status=="400"&&res.reason=="userExist"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userExist'),
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }else if(res.status=="400"&&res.reason=="addUserNone"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.addUser.addUserNone'),
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }else if(res.status=="400"&&res.reason=="userSelf"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userSelf'),
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }else if(res.message=="exist"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.addItem.exist'),
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }else if(res.message){
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "add-item-sub-account"
                    });
                }
            })
        },
        //拼装文件名
        getFolderName(item){
            let folderName = "/"+item.name;
            if(item.pnode){
                folderName = this.getFolderName(item.pnode)+folderName;
            }
            return folderName;
        },
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(901);
                    return;
                }
            });
            this.closeTreeDialog();
            this.$parent.classesOfDialog();
        },
    }
}
</script>

<style scope>
#add-item-sub-account {
    width: 500px;
    /*no*/
    height: 500px;
    /*no*/

}

#add-item-sub-account ul {
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 15px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

#add-item-sub-account li {
    list-style: none;
    min-width: 400px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
}

#add-item-sub-account .tree-node-div {
    word-break: keep-all;
    white-space: nowrap;
    min-width: 460px;
    /*no*/
    height: 40px;
    /*no*/
    overflow: hidden;
}
#add-item-sub-account .tree-nodes .el-loading-spinner .circular {
    height: 20px !important;
    /*no*/
    width: 20px !important;
    /*no*/
}

#add-item-sub-account .tree-nodes .el-loading-spinner {
    margin-top: 0rem !important;
    top: 7%;
}

#add-item-sub-account .tree-nocloud:hover {
    text-decoration: underline;
    cursor: pointer;
}

#add-item-sub-account .tree-nocloud{
    color: #5562B4;
    padding-left: 5%;
}

#add-item-sub-account .task-footer .el-loading-spinner .circular {
    height: 25px !important;
    /*no*/
    width: 25px !important;
    /*no*/
}

#add-item-sub-account .task-footer .el-loading-spinner {
    margin-top: 0rem !important;
    top: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/add_item_popup.vue